import { get } from "lodash";
import log from "loglevel";
import * as t from "types";

export const getRolesReducerResponse = (
  state: any,
  responseType: string
): t.Role[] => {
  log.info("Getting Roles from Store...");
  const value = get(state, `roles.response.${responseType}`);
  return value;
};

export const getPermissionsReducerResponse = (
  state: any,
  responseType: string
): t.Permission[] => {
  log.info("Getting Permissions from Store...");
  const value = get(state, `permissions.response.${responseType}`);
  return value;
};

export const getRolePermissionsReducerResponse = (
  state: any,
  responseType: string
): t.RolePermission[] => {
  log.info("Getting Role Permissions from Store...");
  const value = get(state, `rolePermissions.response.${responseType}`);
  return value;
};
